'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416 from "./presto.-Dashboard-View$$anon$16.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418 from "./presto.-Dashboard-View$$anon$18.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024 from "./presto.types$-Dashboard-System-Stats$.js";
import * as $j_presto$002etypes$0024$002dSite$002dSystem$0024 from "./presto.types$-Site-System$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$15() {
  this.aJC = null;
  this.aJu = null;
  this.aJv = false;
  this.aJD = null;
  this.aJE = false;
  this.aJH = null;
  this.aJA = null;
  this.aJB = false;
  this.aJw = null;
  this.aJx = false;
  this.aJy = null;
  this.aJz = false;
  this.aJF = false;
  this.aJG = false;
  this.aJC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aJH = "DashboardSystemStats";
}
export { $c_Lpresto_DashboardView$$anon$15 as $c_Lpresto_DashboardView$$anon$15 };
$p = $c_Lpresto_DashboardView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$15;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$15() {
}
export { $h_Lpresto_DashboardView$$anon$15 as $h_Lpresto_DashboardView$$anon$15 };
$h_Lpresto_DashboardView$$anon$15.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aJC;
});
$p.L = (function() {
  if ((!this.aJv)) {
    this.aJu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aJv = true;
  }
  return this.aJu;
});
$p.O = (function() {
  if ((!this.aJE)) {
    this.aJD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aJE = true;
  }
  return this.aJD;
});
$p.E = (function() {
  return this.aJH;
});
$p.t = (function() {
  if ((!this.aJB)) {
    this.aJA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("system", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aJB = true;
  }
  return this.aJA;
});
$p.M = (function() {
  if ((!this.aJx)) {
    this.aJw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSite$002dSystem$0024.$m_Lpresto_types$SiteSystem$().ig(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416.$c_Lpresto_DashboardView$$anon$16())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aJx = true;
  }
  return this.aJw;
});
$p.Q = (function() {
  if ((!this.aJz)) {
    this.aJy = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418.$c_Lpresto_DashboardView$$anon$18();
    this.aJz = true;
  }
  return this.aJy;
});
$p.w = (function() {
  if ((!this.aJG)) {
    this.aJF = false;
    this.aJG = true;
  }
  return this.aJF;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee79) => ((p) => \u03b4scrutinee79.cGq(p)))($j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024.$m_Lpresto_types$DashboardSystemStats$())));
});
var $d_Lpresto_DashboardView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$15, "presto.DashboardView$$anon$15", ({
  GG: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$15 as $d_Lpresto_DashboardView$$anon$15 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$15.js.map
